import { useContext } from 'react'

import { Box, Icon, getThemeColor } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ProviderContext } from '../../provider.context'

import * as Styles from './provider-resume-cards.styles'
import {
  ProviderResumeCard,
  ProviderResumeCardsProps,
} from './provider-resume-cards.types'
export const ProviderResumeCards = ({
  iconName,
  iconColor,
}: ProviderResumeCardsProps) => {
  const theme = useTheme()
  const { data, companyTraceabilityStatistics } = useContext(ProviderContext)

  const providerResumeCards: Partial<ProviderResumeCard[]> = [
    companyTraceabilityStatistics?.invoicesPendingQuantitySum,
    {
      ...companyTraceabilityStatistics?.invoicesQuantitySum,
      url: `/invoices/${data?.taxId}`,
    } as ProviderResumeCard,
    companyTraceabilityStatistics?.itemsQuantiySum,
    companyTraceabilityStatistics?.itemsQuantiySumWithOriginPercentage,
  ]
  return (
    <Box width="100%" flexWrap="wrap" gap={3}>
      {providerResumeCards.map(
        (card, index) =>
          card && (
            <a href={card.url ?? undefined}>
              <Styles.CardBox
                key={index}
                borderRadius={theme.border_radius.table}
                boxShadow={theme.box_shadow.card}
                backgroundColor={theme.colors.custom.white}
                padding={2}
                gap={1}
                direction="column"
                flex={1}
                width="50%"
                minWidth="200px"
                maxHeight="110px"
                url={card.url}
              >
                <Box gap={1} alignItems="center">
                  <Icon
                    name={iconName ?? 'receipt'}
                    color={iconColor ?? getThemeColor('primary', theme)}
                    size={20}
                  />
                  <Styles.TitleText
                    size="small"
                    fontWeight={500}
                    color="grey_2"
                  >
                    {card.title}
                  </Styles.TitleText>
                </Box>
                <Styles.ValueText>{card.value}</Styles.ValueText>
                {card.url && (
                  <Styles.UrlIcon>
                    <Icon name="external_link" color="secondary" size={24} />
                  </Styles.UrlIcon>
                )}
              </Styles.CardBox>
            </a>
          ),
      )}
    </Box>
  )
}
